/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTag as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
import { useAppStore } from '@/store/modules/app';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetAnnounceProductList, apiUsdkUpdateAnnounceProduct } from '@/api/usdk';
import USwitch from '@ultra/share/components/USwitch/index.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'exchangeCodeSwitch',
  setup(__props) {
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const filter = ref({
      cids: undefined,
      projectId: undefined,
      env: undefined
    });
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const formRef = ref();
    const multipleSelected = ref([]);
    const type = ref('');
    const form = ref({
      env: 0,
      noticePre: 0,
      noticeLogin: 0,
      noticeForbidPay: 0,
      noticePay: 0,
      codeSw: 0
    });
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'cname'
    }, {
      label: '兑换码开关',
      prop: 'codeSw',
      slot: 'codeSw'
    }, {
      label: '操作',
      action: true
    }];
    const handleChangeMultiple = val => {
      multipleSelected.value = val;
    };
    const getTableData = () => {
      const params = {
        gid: gameInfo.value.Id,
        env: filter.value.env,
        projectId: filter.value.projectId,
        cids: filter.value.cids
      };
      tableLoading.value = true;
      apiUsdkGetAnnounceProductList(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
        tableLoading.value = false;
      });
    };
    const handleClick = (typeE, data) => {
      dialogVisible.value = true;
      type.value = typeE;
      if (typeE === 'conf') {
        form.value = data;
      }
    };
    const handleOk = () => {
      let params = JSON.parse(JSON.stringify(form.value));
      if (type.value === 'batchEdit') {
        params.productIds = multipleSelected.value.map(item => item.productId).join(',');
      } else {
        params.productIds = params.productId;
      }
      params.gid = gameInfo.value.Id;
      confirmLoading.value = true;
      apiUsdkUpdateAnnounceProduct(params).then(res => {
        if (res.code === 0) {
          getTableData();
          handleClose(formRef.value);
          multipleSelected.value = [];
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    const handleClose = formEl => {
      dialogVisible.value = false;
      form.value = {
        env: 0,
        noticePre: 0,
        noticeLogin: 0,
        noticeForbidPay: 0,
        noticePay: 0,
        codeSw: 0
      };
      if (!formEl) return;
      formEl.resetFields();
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_GameChannelSelect = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_el_tag = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "所属渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
            modelValue: _unref(filter).cids,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cids = $event),
            gid: _unref(gameInfo).Id,
            otherProps: {
              needIos: 1,
              isHero: 1
            }
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: getTableData
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => handleClick('batchEdit')),
        disabled: _unref(multipleSelected).length === 0
      }, {
        default: _withCtx(() => [_createTextVNode("批量修改")]),
        _: 1
      }, 8, ["disabled"])])]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading),
        "is-multiple": "",
        onMultipleSelect: handleChangeMultiple
      }, {
        codeSw: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: scope.row.codeSw ? 'success' : 'info'
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.codeSw ? "已开启" : "已关闭"), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('conf', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("配置")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "公告配置",
        width: "500px",
        "before-close": () => handleClose(_unref(formRef))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => handleClose(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => handleOk()),
          loading: _unref(confirmLoading)
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "codeSw",
            label: "兑换码开关"
          }, {
            default: _withCtx(() => [_createVNode(USwitch, {
              modelValue: _unref(form).codeSw,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).codeSw = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "before-close"])], 64);
    };
  }
});